var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container truck-summary-report" },
    [
      _c(
        "el-form",
        {
          attrs: {
            "label-position": "top",
            "label-width": "8em",
            inline: true,
            size: "mini",
          },
        },
        [
          _c(
            "el-row",
            { attrs: { type: "flex", gutter: 8 } },
            [
              _c(
                "el-col",
                { attrs: { xs: 24, sm: 24, md: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "w-100",
                      attrs: { label: _vm.$t("dateRange.dateRange") },
                    },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "daterange",
                          "unlink-panels": "",
                          clearable: false,
                          "start-placeholder": _vm.$t("dateRange.startDate"),
                          "end-placeholder": _vm.$t("dateRange.endDate"),
                          "picker-options": { firstDayOfWeek: 7 },
                          "value-format": "yyyy-MM-dd",
                        },
                        model: {
                          value: _vm.dateRange,
                          callback: function ($$v) {
                            _vm.dateRange = $$v
                          },
                          expression: "dateRange",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { xs: 24, sm: 24, md: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "w-100",
                      attrs: { label: _vm.$t("planning.columns.projectCode") },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "w-100",
                          attrs: { size: "mini", filterable: "", multiple: "" },
                          model: {
                            value: _vm.selectedProjectCodes,
                            callback: function ($$v) {
                              _vm.selectedProjectCodes = $$v
                            },
                            expression: "selectedProjectCodes",
                          },
                        },
                        _vm._l(_vm.$projectCodes, function (item) {
                          return _c("el-option", {
                            key: item.RecId,
                            attrs: {
                              label: item.ProjectCode,
                              value: item.ProjectCode,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { xs: 24, sm: 24, md: 8 } },
                [
                  _c(
                    "el-form-item",
                    { staticClass: "padding-top-28" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.getData("data")
                            },
                          },
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: {
                              icon: "search",
                              "aria-hidden": "true",
                              size: "sm",
                            },
                          }),
                          _c("span", { staticClass: "ml-1" }, [
                            _vm._v(_vm._s(_vm.$t("general.search"))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { staticClass: "padding-top-28" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.getData("xls")
                            },
                          },
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: {
                              icon: "file-excel",
                              "aria-hidden": "true",
                              size: "sm",
                            },
                          }),
                          _c("span", { staticClass: "ml-1" }, [
                            _vm._v(_vm._s(_vm.$t("general.downloadExcel"))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      !_vm.loading
        ? _c(
            "div",
            { staticClass: "truck-summary-report" },
            [
              _c(
                "el-table",
                {
                  ref: "loadPlanTable",
                  staticClass: "mt-3",
                  attrs: {
                    size: "mini",
                    border: "",
                    stripe: "",
                    data: _vm.reportData,
                  },
                  on: { "row-click": _vm.handleRowClick },
                },
                [
                  _c("el-table-column", {
                    attrs: { fixed: "", type: "index", width: "50" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("truck.truckPlateNum"),
                      prop: "plateNumber",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { label: _vm.$t("planning.distance"), width: "100" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return scope.row.routes.length > 0
                              ? [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        Math.round(
                                          parseFloat(
                                            _vm.helper.sumBy(
                                              scope.row.routes,
                                              function (route) {
                                                return route.distance || 0
                                              }
                                            )
                                          ) / 1000
                                        ) + " KM"
                                      ) +
                                      " "
                                  ),
                                ]
                              : undefined
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("planning.tooltip.time"),
                      width: "100",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return scope.row.routes.length > 0
                              ? [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        Math.round(
                                          parseFloat(
                                            _vm.helper.sumBy(
                                              scope.row.routes,
                                              function (route) {
                                                return route.time || 0
                                              }
                                            )
                                          ) / 60
                                        ) + " MINS"
                                      ) +
                                      " "
                                  ),
                                ]
                              : undefined
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("general.totalOrders"),
                      width: "100",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                " " + _vm._s(scope.row.orders.length) + " "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2808700626
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("dashboard.totalWaypoints"),
                      width: "100",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                " " + _vm._s(scope.row.waypoints.length) + " "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1079590751
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { type: "expand" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-table",
                                {
                                  staticClass: "m-3",
                                  staticStyle: { width: "calc(100% - 32px)" },
                                  attrs: {
                                    size: "mini",
                                    border: "",
                                    stripe: "",
                                    data: scope.row.routes,
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: { type: "index" },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: _vm.$t(
                                        "planning.columns.planCode"
                                      ),
                                      prop: "planCode",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: _vm.$t("planning.columns.planId"),
                                      prop: "planId",
                                      width: "120",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: _vm.$t("planning.columns.zone"),
                                      prop: "zone",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: _vm.$t(
                                        "planning.gMap.waypointType"
                                      ),
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (prop) {
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "planning.waypointType." +
                                                        prop.row.waypointType
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: _vm.$t("planning.gMap.district"),
                                      prop: "district",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: _vm.$t("planning.tooltip.address"),
                                      prop: "displayAddress",
                                      "show-overflow-tooltip": "",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: _vm.$t("planning.distance"),
                                      width: "80",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (prop) {
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    Math.round(
                                                      prop.row.distance / 1000
                                                    ) + " KM"
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: _vm.$t("planning.tooltip.time"),
                                      width: "80",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (prop) {
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    Math.round(
                                                      prop.row.time / 60
                                                    ) + " MINS"
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: _vm.$t("planning.tooltip.start"),
                                      prop: "startTime",
                                      width: "140",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: _vm.$t("planning.tooltip.endTime"),
                                      prop: "endTime",
                                      width: "140",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2597756091
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }